<template src="./Agendar.html"></template>

<script>
import DatePicker from "../DatePicker/Datepicker";
import moment from "moment-timezone";
const moment_tz = require("moment-timezone");
import metodos_comunes from "../../js/metodos_comunes";
import {
  consultarDisponibilidad,
  agendarCita
} from "../../apiService/request/Agendamiento";

export default {
  data() {
    return {
      reglasObligatorio: [v => !!v || "Campo obligatorio"],
      fechaSeleccionada: "",
      horaSeleccionada: "",
      horarioSeleccionado: "",
      descripcion: "",
      contenedorAgendar: 0,
      reglasTelefono: [
        v => !!v || "El telefono es requerido",
        v =>
          (v && v.toString().length >= 7) ||
          "El telefono debe tener 7 o más caracteres"
      ],
      telefono: this.$store.getters.getTelefonoPaciente,
    };
  },
    props: {
    confirmarCita:{
      type: Boolean
    }
  },
  components: { DatePicker },
  methods: {
    formatoFecha() {
      let fecha = moment(this.fechaSeleccionada).format("YYYY-MM-DD HH:mm");
      let horaAgendar = this.horaSeleccionada;
      let unionFecha = fecha.toString().slice(0, 11) + this.horaSeleccionada;
      this.horarioSeleccionado = Number(
        moment(unionFecha, "YYYY-MM-DD HH:mm", "America/Bogota").format("x")
      );
    },
    dispatchTelefonoPaciente() {
      this.$store.dispatch("setTelefonoPaciente", Number(this.telefono));
    },
    async confirmar() {
      // if (
      //   this.$refs &&
      //   this.$refs.formAgendamiento &&
      //   this.$refs.formAgendamiento.validate()
      // ) {
      this.consultando = true;
      const data = {
        documento: this.$store.getters.getCedulaPaciente,
        key: this.$store.getters.getEvento,
        fechaHoraCita: this.horarioSeleccionado,
        nombrePaciente: this.$store.getters.getNombrePaciente,
        telefono: this.$store.getters.getTelefonoPaciente,
        nombrePrestacion: this.$store.getters.getNombrePrestacion,
        agendadoPor: this.$store.state.provider_email,
        ordenId: this.$store.getters.getOrdenId,
        cups: this.$store.getters.getCups.toString(),
        sede: this.$store.getters.getSede,
        descripcion: this.descripcion
      };
      const respuesta = await agendarCita(data)
        .then(res => res)
        .catch(err => err);
      this.$store.dispatch("cambiarEstadoModal", true);
      this.$store.dispatch("cambiarMensajeModal", respuesta);
      this.consultando = true;
      if (this.confirmarCita == true && respuesta.data.message == "Cita agendada con éxito.") {
        this.$emit("confirmarCitaAbierto");
      } else if(this.confirmarCita == false && respuesta.data.message == "Cita agendada con éxito.") {
        this.$store.dispatch("setMensajeChatBox", "Salir de Agendamiento");
      }else{
      this.cancelar();}
    },

    cancelar() {
      this.horaSeleccionada = "";
      this.fechaSeleccionada = "";
      this.horarioSeleccionado = "";
      this.descripcion ="";
      this.contenedorAgendar += 1;
    }
  }
};
</script>

<style lang="scss" src="./Agendar.scss" scoped></style> 
<style lang="scss" src="./Agendar.scss">
.contenedorAgendar {
  .autocomplete {
    // margin-top: 19px;
    border-radius: 24px !important;
    .v-input__control {
      .v-input__slot {
        background-color: #f3f3f3 !important;
        .v-select__slot {
          input {
            color: #2d2d2d !important;
            font-weight: 600;
          }
          .mdi-menu-down::before {
            color: #3a899a !important;
            height: 28px;
            font-size: 28px;
          }
        }
      }
      .v-text-field__details {
        padding-left: 3%;
      }
    }
  }
  .autocomplete-llenado {
    border-radius: 24px !important;
    .v-input__control {
      .v-input__slot {
        background-color: #d9edf0 !important;
        .v-select__slot {
          input {
            color: #575757 !important;
            font-weight: 600;
          }
          .mdi-menu-down::before {
            color: #575757 !important;
            height: 28px;
            font-size: 28px;
          }
        }
      }
      .v-text-field__details {
        padding-left: 3%;
      }
    }
  }
}
</style> 


// WEBPACK FOOTER //
// src/components/Agendar/Agendar.vue